import React, { useContext, useEffect, useState } from "react";
import HeartIcon from "../../../icons/HeartIcon";
import { CDN_BASE_URL } from "../../../config";
import { priceComma } from "../../../utils/priceComma";
import { Link } from "react-router-dom";
import ShareModal from "./ShareModal";
import { httpReauest } from "../../../utils/httpRequest";
import axios from "axios";
import { getTiming } from "../../../utils/getTiming";

const ProductCardMobile = ({ data }) => {
  const [share, setShare] = useState();
  const url = `https://1924.ir/${data?.url?.category?.url}/${data?.url?.brand?.name}/${data?.url?.name}/${data?.vehicle_number}`;
  const [liked, setLiked] = useState();
  const [count, setcount] = useState(0);

  const now = new Date();
  const newTime = now.getTime() - new Date(data?.createdAt).getTime();
  const hour = newTime / 86400000;

  useEffect(() => {
    if (data?.liked) {
      setLiked(true);
    }
    setcount(data?.like);
  }, []);

  async function handleLike() {
    if (!liked) {
      setLiked(true);
      setcount(count + 1);
      const { data: data2 } = await axios.get(
        "https://api.ipify.org/?format=json"
      );
      await httpReauest(
        "POST",
        "/vehicle/like",
        { ip: data2.ip, vehicle: data?._id },
        {}
      );
    } else {
      setLiked(false);
      setcount(count - 1);
      const { data: data2 } = await axios.get(
        "https://api.ipify.org/?format=json"
      );
      await httpReauest(
        "DELETE",
        "/vehicle/like/delete",
        { ip: data2.ip, vehicle: data?._id },
        {}
      );
    }
  }

  return (
    <div className="my-4">
      <Link
        to={`/${data?.url?.category?.url}/${data?.url?.brand?.name}/${data?.url?.name}/${data?.vehicle_number}`}
        title={`مشخصات محصول ${data?.name}`}
      >
        {data?.img?.img_webp ? (
          <picture>
            <source
              type="image/webp"
              srcset={CDN_BASE_URL + data?.img?.img_webp}
            />
            <img
              src={CDN_BASE_URL + data?.img_jpg}
              className="rounded-[10px] w-full mt-6 object-cover h-[350px] sm:h-[600px]"
              alt={data.name}
              loading={"lazy"}
            />
          </picture>
        ) : data?.img ? (
          <img
            src={CDN_BASE_URL + data?.img}
            className="rounded-[10px] w-full mt-6 object-cover h-[350px] sm:h-[600px]"
            alt={data.name}
            loading={"lazy"}
          />
        ) : (
          <img
            src={"/no-image.jpg"}
            className="rounded-[10px] w-full mt-6 object-cover h-[350px] sm:h-[600px]"
            alt="Not Found"
            loading="lazy"
          />
        )}
      </Link>

      <div className="flex justify-between items-center py-2">
        <span className="flex gap-3 items-center">
          <span className="flex gap-2 items-center">
            {" "}
            <HeartIcon select={liked} onClick={handleLike} color={"#2E3132"} />
            <p>{count}</p>
          </span>
          <span className="flex gap-2 items-center">
            {" "}
            <img className="w-[20px]" src="/Chat.png" alt="" />
            <p>{data?.commentCount}</p>
          </span>
        </span>
        <span className="flex gap-3 items-center">
          <span
            onClick={() => setShare(true)}
            className="flex gap-2 items-center"
          >
            {" "}
            <img className="w-[20px]" src="/share.png" alt="" />
          </span>
          <span>{getTiming(hour)}</span>
        </span>
      </div>
      <div className="flex justify-between items-center py-1 font-[700] text-[18px]">
        <h2>{data?.name}</h2>
        <span className="font-[500] text-[14px]">مدل:{data?.year}</span>
        <p>
          {data?.no_price
            ? "توافقی"
            : priceComma(Number(data?.price * 1000000000).toFixed(0), 2)}
        </p>
      </div>
      <p className="text-justify">
        {data?.desc?.slice(0, 200)}{" "}
        <Link
          to={`/${data?.url?.category?.url}/${data?.url?.brand?.name}/${data?.url?.name}/${data?.vehicle_number}`}
          className="text-[#FFA800] font-bold ms-1"
          title={`اطلاعات ${data?.name}`}
        >
          اطلاعات {data?.name}
        </Link>
      </p>
      {share && <ShareModal url={url} setShare={setShare} />}
    </div>
  );
};

export default ProductCardMobile;
